import { AccountParticipationLevel, CashInCashOutType } from '@nemuru-eng/js-api-client';
import { z } from 'zod';

import { GetTextIdTranslationType } from '@/components/shared/hooks/useTranslation';
import { requiredEnum, requiredString } from '@/utils/zodUtils';
import { validateIban } from '@/utils/zodValidation/validateIban';

export const BankAccountDetailsFormSchema = (t: GetTextIdTranslationType) =>
  z
    .object({
      accountNumber: z.string().nullable(),
      accountHolderFirstName: requiredString(t),
      accountHolderFirstLastName: requiredString(t),
      accountHolderSecondLastName: requiredString(t),
      accountHolderParticipationLevel: requiredEnum(AccountParticipationLevel, t),
      description: requiredString(t),
      type: requiredEnum(CashInCashOutType, t),
    })
    .strict()
    .refine(
      (data) => {
        if (data.type !== CashInCashOutType.FLYWIRE) return validateIban(data.accountNumber);
        return true;
      },
      {
        message: t('ACCOUNT_NUMBER_IS_NOT_VALID'),
        path: ['accountNumber'],
      },
    );

export type BankAccountDetailsFormType = z.infer<ReturnType<typeof BankAccountDetailsFormSchema>>;
